module.exports = require("core-js/library/fn/object/get-prototype-of");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/get-prototype-of.js
// module id = 17
// module chunks = 35783957827783 52252321336229